import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { RequestInterceptor } from '../interceptors/request.interceptor';
import { ResponseInterceptor } from '../interceptors/response.interceptor';
import { LogHelper } from '../helpers/log.helper';
import { RequestHelper } from '../helpers/request.helper';
import { IdentityOptions } from '../types/internal-types';
import { OptionsService } from '../services/options.service';

// tslint:disable-next-line:typedef
export function provideIdentity(options: IdentityOptions) {
	LogHelper.options = options;
	RequestHelper.options = options;

	return [
		{ provide: OptionsService, useValue: new OptionsService(options) },
		{ provide: HTTP_INTERCEPTORS, useClass: RequestInterceptor, multi: true },
		{ provide: HTTP_INTERCEPTORS, useClass: ResponseInterceptor, multi: true }
	];
}
